class GroupsTagify {
    constructor(inputElm, groups) {
        const onSelectSuggestion = (e) => {
            if( e.detail.event.target.matches('.remove-all-tags')) {
                tagify.removeAllTags()
            }
            // custom class from "dropdownHeaderTemplate"
            else if( e.detail.event.target.matches('.add-all-tags') ) {
                let selectedItems = tagify.dropdown.getAllSuggestionsRefs();
                let tagsToAdd = [];
                for (let i in selectedItems){
                    if(selectedItems[i].attributes.uuid){
                        let obj = groups.find(o => o.value === selectedItems[i].attributes.value.value);
                        tagsToAdd.push(obj);
                    }
                }
                tagify.addTags(tagsToAdd, true, true);
                tagify.dropdown.hide();
            }
        }

        const tagify = new Tagify(inputElm, {
            tagTextProp: 'name', // very important since a custom template is used with this property as text
            enforceWhitelist: true,
            skipInvalid: true, // do not remporarily add invalid tags
            edit: false,
            dropdown: {
                placeAbove: false,
                closeOnSelect: false,
                enabled: 0,
                maxItems: 500,
                searchKeys: ['name']  // very important to set by which keys to search for suggesttions when typing
            },
            templates: {
                tag: this.tagTemplate,
                dropdownItem: this.suggestionItemTemplate,
                dropdownHeader: this.dropdownHeaderTemplate,
                dropdownItemNoMatch: tagData =>
                    `<div class='${tagify.settings.classNames.dropdownItem} text-primary' value="noMatch" tabindex="0" role="option">
                        No Groups found for: <strong>${tagData.value}</strong>
                    </div>`
            },
            whitelist: groups,
        }).on('dropdown:select', onSelectSuggestion);
        return tagify;
    }
    tagTemplate(tagData){
        const getGroupTagHtml = (tagData) => {
            return new GroupInfoGenerator().generateMemberTableView(tagData['name'], false, tagData['uuid'], '', 25, 10, 9, 7, 8, 2);
        }

        return `<tag title="${tagData.name}"
                        contenteditable='false'
                        spellcheck='false'
                        tabIndex="-1"
                        class="tagify__tag p-1 ${tagData.class ? tagData.class : ""}"
                        ${this.getAttributes(tagData)}>
                    <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
                    ${getGroupTagHtml(tagData)}
                </tag>`;
    }

    suggestionItemTemplate(tagData){
        const getGroupHtml = (tagData) => {
            return new GroupInfoGenerator().generateMemberTableView(tagData['name'], false, tagData['uuid'], tagData['numberOfMembers'], 35, 10, 8, 7, 8);
        }

        return `<div ${this.getAttributes(tagData)}
                    class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'
                    tabindex="0"
                    role="option">
                    ${getGroupHtml(tagData)}
                </div>`;
    }

    dropdownHeaderTemplate(suggestions){
        return `<header data-selector='tagify-suggestions-header' class="${this.settings.classNames.dropdownItem}">
                    <div class="d-flex justify-content-between text-primary">
                        <strong class="text-decoration-underline-ga primary add-all-tags">Add All</strong>
                        ${this.value.length ? `<a class='remove-all-tags text-decoration-underline-ga danger text-danger'>Remove all</a>` : ''}
                    </div>
                    <span class="text-primary">${suggestions.length} Groups</span>
                </header>`;
    }
}
window.GroupsTagify = GroupsTagify;